import { render, staticRenderFns } from "./printer-receipt-attributes.vue?vue&type=template&id=bb09f750&scoped=true"
import script from "./printer-receipt-attributes.vue?vue&type=script&lang=js"
export * from "./printer-receipt-attributes.vue?vue&type=script&lang=js"
import style0 from "./printer-receipt-attributes.vue?vue&type=style&index=0&id=bb09f750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb09f750",
  null
  
)

export default component.exports